/**
 * The identity props the tracking spec marks "null for ...": always sent, as
 * `null` when empty, so an event view and a CTA click carry the same keys.
 */
export type EventIdentityProps = {
  s_booking_form_id: string | null;
  event_id: string | null;
  is_public_event: boolean;
  s_club_id: string | null;
  s_group_id: string | null;
  source_type: string | null;
};

/**
 * Who an event belongs to. A booking form event has a booking form id; a public
 * event has an event id and no booking form id.
 */
export function getEventIdentityProps({
  eventId,
  isPublicEvent,
  clubId,
  groupId,
  sourceType,
}: {
  eventId: string | null;
  isPublicEvent: boolean;
  clubId?: string | null;
  groupId?: string | null;
  sourceType?: string | null;
}): EventIdentityProps {
  return {
    s_booking_form_id: isPublicEvent ? null : eventId,
    event_id: isPublicEvent ? eventId : null,
    is_public_event: isPublicEvent,
    s_club_id: clubId || null,
    s_group_id: groupId || null,
    source_type: sourceType || null,
  };
}

export type ClubIdentityProps = {
  s_club_id: string | null;
  s_group_id: null;
  external_club_id: string | null;
  source_type: "club";
};

export type CtaIdentityProps = EventIdentityProps & {
  external_club_id: string | null;
  is_booking_form: boolean;
  is_club: boolean;
};

export function getClubIdentityProps({
  clubId,
  isSpondClub,
}: {
  clubId: string | null;
  isSpondClub: boolean;
}): ClubIdentityProps {
  return {
    s_club_id: isSpondClub ? clubId : null,
    s_group_id: null,
    external_club_id: isSpondClub ? null : clubId,
    source_type: "club",
  };
}
